import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "activity-card" };
const _hoisted_2 = {
    key: 1,
    class: "activity-card__error"
};
const _hoisted_3 = {
    key: 3,
    class: "activity-card__empty"
};
const _hoisted_4 = { class: "activity-timeline" };
const _hoisted_5 = {
    key: 0,
    class: "activity-entry"
};
const _hoisted_6 = { class: "activity-entry__rail" };
const _hoisted_7 = { class: "activity-entry__body" };
const _hoisted_8 = { class: "activity-entry__meta" };
const _hoisted_9 = { class: "activity-entry__author" };
const _hoisted_10 = {
    key: 0,
    class: "activity-entry__entity"
};
const _hoisted_11 = {
    key: 1,
    class: "activity-entry__entity"
};
const _hoisted_12 = { class: "activity-entry__time" };
const _hoisted_13 = {
    key: 0,
    class: "activity-entry__action"
};
const _hoisted_14 = { class: "activity-entry__action" };
const _hoisted_15 = {
    key: 0,
    class: "activity-entry__edited"
};
const _hoisted_16 = {
    key: 0,
    class: "activity-note-edit"
};
const _hoisted_17 = {
    key: 0,
    class: "activity-note-edit__error"
};
const _hoisted_18 = { class: "activity-note-edit__actions" };
const _hoisted_19 = {
    key: 1,
    class: "activity-entry__note"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src", "onError"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    key: 4,
    class: "activity-ack"
};
const _hoisted_24 = ["aria-label", "disabled", "onClick"];
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
    key: 0,
    class: "activity-ack__names"
};
const _hoisted_27 = {
    key: 1,
    class: "activity-ack__error"
};
const _hoisted_28 = { class: "activity-entry__action" };
const _hoisted_29 = { class: "activity-entry__detail" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
    key: 3,
    class: "activity-entry__action"
};
const _hoisted_32 = {
    key: 5,
    class: "activity-entry__action"
};
const _hoisted_33 = { class: "activity-entry__action" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = { class: "activity-entry__note" };
const _hoisted_36 = {
    key: 9,
    class: "activity-entry__action"
};
const _hoisted_37 = {
    key: 0,
    class: "activity-card__pagination"
};
const _hoisted_38 = { class: "image-viewer" };
const _hoisted_39 = { class: "image-viewer__bar" };
const _hoisted_40 = { class: "image-viewer__title" };
const _hoisted_41 = ["src", "alt"];
import UserNote from "@/components/UserNote.vue";
import StatusNoteText from "@/components/StatusNoteText.vue";
import { ref, onMounted, computed } from "vue";
import { useDate } from "vuetify";
import { orderInfoService } from "@/services/orderInfoService";
import { intakeService } from "@/services/intakeService";
import { AuditEntry } from "@/models/audit";
import { ApiError, useApiPaginator } from "@/services/api";
import { intakeStatusLabel } from "@/models/intakeStatus";
import { pluralize, formatContactNumber } from "@/utils";
import { USER_NOTE_LEVEL } from "@/models/userNote";
import { isValidS3FileUrl } from "@/services/uploadService";
import { userNotesService } from "@/services/userNotesService";
import { useAuthStore, useRequirementsStore } from "@/stores";
/** Identity for one document: the S3 path without query params.
 *
 * Not the basename, and not the label: the basename and the label are both shared by two documents
 * a partner uploaded under one filename (LAM-5227), and dropping the query is what keeps a presigned
 * link re-signed with a fresh token from reading as a remove plus an add. */
export default /*@__PURE__*/ _defineComponent({
    __name: 'AuditLogList',
    props: {
        orderInfoId: {
            type: String,
            required: false,
            default: null,
        },
        intakeOrderId: {
            type: Number,
            required: false,
            default: null,
        },
        intakeDocumentId: {
            type: String,
            required: false,
            default: null,
        },
        withNotes: {
            type: Boolean,
            required: false,
            default: true,
        },
        tagDefs: {
            type: Array,
            required: false,
            default: null,
        },
    },
    emits: ["warning-note", "mentions-sent"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const entries = ref([]);
        const showLoader = ref(true);
        const errorMsg = ref(null);
        const apiMethod = props.orderInfoId
            ? orderInfoService.getOrderAuditLogs
            : props.intakeOrderId
                ? intakeService.getOrderAuditLogs
                : props.intakeDocumentId
                    ? intakeService.getIntakeDocumentAuditLogs
                    : () => Promise.resolve({ results: [] });
        const paginator = useApiPaginator(apiMethod, props.orderInfoId ?? props.intakeOrderId ?? props.intakeDocumentId);
        const hasNext = computed(() => paginator.hasNext.value);
        const hasPrevious = computed(() => paginator.hasPrevious.value);
        const dateAdapter = useDate();
        const authStore = useAuthStore();
        const currentUserId = authStore.userInfo?.pk;
        const requirementsStore = useRequirementsStore();
        const tagLabels = computed(() => {
            const config = requirementsStore.clientConfig;
            const defs = props.tagDefs ?? [
                ...(config?.intake?.availableTags || []),
                ...(config?.priorAuth?.availableTags || []),
            ];
            return Object.fromEntries(defs.map((def) => [def.key, def.label]));
        });
        const editingNoteId = ref(null);
        const editNoteText = ref("");
        const savingNoteEdit = ref(false);
        const editNoteError = ref(null);
        const canEditNote = (entry) => Boolean(entry.userNote &&
            currentUserId != null &&
            entry.userNote.user === currentUserId &&
            entry.userNote.level !== USER_NOTE_LEVEL.ARCHIVE_REASON &&
            noteText(entry));
        const startNoteEdit = (entry) => {
            editingNoteId.value = entry.userNote.id;
            editNoteText.value = entry.userNote.note || "";
            editNoteError.value = null;
        };
        const cancelNoteEdit = () => {
            editingNoteId.value = null;
            editNoteText.value = "";
            editNoteError.value = null;
        };
        const saveNoteEdit = async (entry) => {
            const text = editNoteText.value.trim();
            if (!text || savingNoteEdit.value)
                return;
            savingNoteEdit.value = true;
            editNoteError.value = null;
            try {
                const updated = await userNotesService.updateNote(entry.userNote.id, { note: text });
                entry.userNote.note = updated?.note ?? text;
                entry.userNote.edited = updated?.edited ?? true;
                cancelNoteEdit();
            }
            catch {
                editNoteError.value = "Failed to save your edit — please try again.";
            }
            finally {
                savingNoteEdit.value = false;
            }
        };
        const ackPending = ref(new Set());
        const ackErrors = ref(new Set());
        const canAcknowledge = (entry) => Boolean(entry.userNote && currentUserId != null && (entry.userNote.user || ackCount(entry)));
        const ackList = (entry) => entry.userNote?.acknowledgements ?? [];
        const ackCount = (entry) => ackList(entry).length;
        const hasAcked = (entry) => ackList(entry).some((ack) => Number(ack.user) === Number(currentUserId));
        const ackNames = (entry) => ackList(entry)
            .map((ack) => ack.userFullName)
            .filter(Boolean)
            .join(", ");
        const toggleAcknowledge = async (entry) => {
            const note = entry.userNote;
            if (!note || currentUserId == null || ackPending.value.has(note.id))
                return;
            ackErrors.value.delete(note.id);
            const previous = ackList(entry);
            const acked = hasAcked(entry);
            const optimisticName = `${authStore.userInfo?.firstName ?? ""} ${authStore.userInfo?.lastName ?? ""}`.trim();
            note.acknowledgements = acked
                ? previous.filter((ack) => Number(ack.user) !== Number(currentUserId))
                : [...previous, { user: Number(currentUserId), userFullName: optimisticName, createdOn: new Date().toISOString() }];
            ackPending.value.add(note.id);
            try {
                const response = acked
                    ? await userNotesService.unacknowledgeNote(note.id)
                    : await userNotesService.acknowledgeNote(note.id);
                note.acknowledgements = response?.acknowledgements ?? note.acknowledgements;
            }
            catch {
                note.acknowledgements = previous;
                ackErrors.value.add(note.id);
            }
            finally {
                ackPending.value.delete(note.id);
            }
        };
        const addNote = () => {
            fetchEntries();
        };
        onMounted(async () => {
            await fetchEntries();
        });
        const fetchEntries = async () => {
            try {
                showLoader.value = true;
                const response = await paginator.fetch();
                handleEntriesFetch(response);
            }
            catch (e) {
                // TODO: handle error
                errorMsg.value = e instanceof ApiError ? e.message.toString() : "An unknown error occurred";
            }
            finally {
                showLoader.value = false;
            }
        };
        __expose({
            refresh: fetchEntries,
        });
        const fetchPage = async (isNext) => {
            try {
                showLoader.value = true;
                const response = isNext ? await paginator.next() : await paginator.previous();
                handleEntriesFetch(response);
            }
            finally {
                showLoader.value = false;
            }
        };
        const handleEntriesFetch = (response) => {
            if (response) {
                entries.value = response.results.map((entry) => new AuditEntry(entry, dateAdapter));
                // Find any warning level notes and emit the first one
                const warningsThreshold = new Date(Date.now() - 1000 * 60 * 60 * 24 * 5); // 5 days
                const warning = entries.value.find((entry) => entry.userNote?.level === "warning" && new Date(entry.userNote?.createdOn) > warningsThreshold);
                if (warning) {
                    emit("warning-note", warning);
                }
            }
            else {
                entries.value = [];
            }
        };
        const entryKind = (entry) => {
            if (entry.userNote)
                return noteAttachment(entry) && !noteText(entry) ? "file" : "note";
            if (entry.outgoingFaxTask || entry.incomingFax)
                return "fax";
            if (entry.logEntry?.action === "create")
                return "create";
            if (isTagOnlyChange(entry))
                return "tag";
            return "update";
        };
        const entryIcon = (entry) => {
            switch (entryKind(entry)) {
                case "note":
                    return "mdi-note-text-outline";
                case "file":
                    return "mdi-paperclip";
                case "fax":
                    return "mdi-fax";
                case "create":
                    return "mdi-plus";
                case "tag":
                    return "mdi-tag-outline";
                default:
                    return "mdi-swap-horizontal";
            }
        };
        const downloadFiles = (fileLinks) => {
            function _download(fileLink) {
                // Window.open seems to be the most reliable method
                window.open(fileLink, "_blank");
            }
            let index = 0;
            for (const fileLink of fileLinks) {
                // Space out the downloads, so the browser does not skip any files
                setTimeout(() => _download(fileLink), 200 * index++);
            }
        };
        const FILE_NOTE_REGEX = /^\[FILE:([^\]]+)\]\(([^)]+)\)$/;
        /**
         * Parses a file note from the format [FILE:filename](url) and validates
         * that the URL is a valid S3 file URL based on backend validation logic.
         * This prevents XSS attacks via javascript: or data: URLs.
         */
        const parseFileNote = (noteText) => {
            if (!noteText)
                return null;
            const match = noteText.match(FILE_NOTE_REGEX);
            if (match) {
                const fileUrl = match[2];
                // Validate the URL using the same logic as the backend S3 storage
                if (!isValidS3FileUrl(fileUrl)) {
                    return null;
                }
                return { fileName: match[1], fileUrl };
            }
            return null;
        };
        const fileNotes = computed(() => {
            const map = new Map();
            for (const entry of entries.value) {
                if (entry.userNote?.note) {
                    const parsed = parseFileNote(entry.userNote.note);
                    if (parsed) {
                        map.set(entry.id, parsed);
                    }
                }
            }
            return map;
        });
        const noteAttachment = (entry) => {
            const note = entry.userNote;
            if (!note)
                return null;
            if (note.attachmentUrl && note.attachmentFilename) {
                return { fileName: note.attachmentFilename, fileUrl: note.attachmentUrl };
            }
            return fileNotes.value.get(entry.id) ?? null;
        };
        const brokenImageUrls = ref(new Set());
        // Image-ness comes from the stored S3 key (URL path), never the display filename — paperclip
        // uploads convert PNG/JPG to PDF while attachment_filename keeps the original image name.
        const isImageAttachmentUrl = (fileUrl) => {
            try {
                return /\.(png|jpe?g)$/i.test(new URL(fileUrl).pathname);
            }
            catch {
                return false;
            }
        };
        // Inline render only for server-issued attachment URLs — legacy [FILE:] marker URLs are
        // user-authored note text and stay click-gated behind the chip.
        const showInlineImage = (entry) => {
            if (!entry.userNote?.attachmentUrl)
                return false;
            const attachment = noteAttachment(entry);
            return !!attachment && isImageAttachmentUrl(attachment.fileUrl) && !brokenImageUrls.value.has(attachment.fileUrl);
        };
        const imageViewerOpen = ref(false);
        const imageViewerUrl = ref("");
        const imageViewerName = ref("");
        const openImageViewer = (entry) => {
            const attachment = noteAttachment(entry);
            if (!attachment)
                return;
            imageViewerUrl.value = attachment.fileUrl;
            imageViewerName.value = attachment.fileName;
            imageViewerOpen.value = true;
        };
        const onViewerImageError = () => {
            if (imageViewerUrl.value)
                brokenImageUrls.value.add(imageViewerUrl.value);
            imageViewerOpen.value = false;
        };
        const noteText = (entry) => {
            const text = entry.userNote?.note;
            if (!text || parseFileNote(text))
                return null;
            return text;
        };
        const parseTagKeys = (value) => {
            let parsed = value;
            if (typeof value === "string") {
                try {
                    parsed = JSON.parse(value);
                }
                catch {
                    return [];
                }
            }
            if (!Array.isArray(parsed))
                return [];
            return [...new Set(parsed.filter((key) => typeof key === "string"))];
        };
        const tagLabel = (key) => tagLabels.value[key] ?? key;
        const tagChangeDetails = (entry) => {
            const change = entry.logEntry?.changesDict?.statusTags;
            if (!Array.isArray(change) || change.length !== 2)
                return [];
            const oldKeys = parseTagKeys(change[0]);
            const newKeys = parseTagKeys(change[1]);
            const added = newKeys.filter((key) => !oldKeys.includes(key)).map(tagLabel);
            const removed = oldKeys.filter((key) => !newKeys.includes(key)).map(tagLabel);
            const details = [];
            if (added.length)
                details.push(`Added ${pluralize(added.length, "tag")} ${added.join(", ")}`);
            if (removed.length)
                details.push(`Removed ${pluralize(removed.length, "tag")} ${removed.join(", ")}`);
            return details;
        };
        const isTagOnlyChange = (entry) => {
            if (entry.logEntry?.action !== "update")
                return false;
            const keys = Object.keys(entry.logEntry?.changesDict || {});
            return keys.length === 1 && keys[0] === "statusTags";
        };
        // Shared by intake order + document audit rows — both render snooze/status the same way.
        const intakeStatusDetails = (entry) => {
            let details = [];
            const changes = entry.logEntry?.changesDict;
            if (changes?.snoozeUntil) {
                const [start, end] = changes.snoozeUntil;
                details.push(`Snooze ${start !== "None" ? new Date(start).toLocaleString() : "None"} ->` +
                    ` ${end !== "None" ? new Date(end).toLocaleString() : "None"}`);
            }
            if (changes?.status) {
                details.push(`Status ${intakeStatusLabel(changes.status[0])} -> ${intakeStatusLabel(changes.status[1])}`);
            }
            details.push(...tagChangeDetails(entry));
            return details;
        };
        const orderInfoDetails = (entry) => {
            let details = [];
            const changes = entry.logEntry?.changesDict;
            // Handle checklist fields specially
            if (changes?.checklist) {
                const [oldChecklist, newChecklist] = changes.checklist;
                const checklistDetails = formatChecklistChanges(oldChecklist, newChecklist);
                details.push(...checklistDetails);
            }
            if (changes?.basicPlusChecklist) {
                const [oldChecklist, newChecklist] = changes.basicPlusChecklist;
                const checklistDetails = formatChecklistChanges(oldChecklist, newChecklist);
                details.push(...checklistDetails);
            }
            // Handle secondary diagnosis field specially
            if (changes?.secondaryDiagnosis) {
                const [oldDiagnosis, newDiagnosis] = changes.secondaryDiagnosis;
                const diagnosisDetails = formatSecondaryDiagnosisChanges(oldDiagnosis, newDiagnosis);
                details.push(...diagnosisDetails);
            }
            // Handle patient chart field specially (track file names, ignore URL token refreshes)
            if (changes?.patientChart) {
                const [oldChart, newChart] = changes.patientChart;
                const chartDetails = formatPatientChartChanges(oldChart, newChart);
                details.push(...chartDetails);
            }
            // Handle medical necessity field specially (track file names, ignore URL token refreshes)
            if (changes?.medicalNecessity) {
                const [oldNecessity, newNecessity] = changes.medicalNecessity;
                const necessityDetails = formatMedicalNecessityChanges(oldNecessity, newNecessity);
                details.push(...necessityDetails);
            }
            details.push(...tagChangeDetails(entry));
            // Handle other common field changes
            const fieldsToExclude = [
                "patientChart",
                "medicalNecessity",
                "statusTags",
                "patientSsn",
                "ncitCode",
                "pharmacyInfo",
                "patientHeight",
                "patientWeight",
                "provideEmail",
                "outgoingFaxTasks",
                "notes",
                "providerDeaNumber",
                "providerSpecialty",
                "providerContactName",
                "providerOfficePhone",
                "providerFax",
                "providerTin",
                "providerTitle",
                "providerLicenseNumber",
                "insurancePlanTypeDetails",
                "patientInsuranceMemberName",
                "extraStructuredInformation",
                "filledFormUrl",
                "statusModifiedOn",
                "user",
                "checklist", // Exclude checklist from general handling since we handle it specially
                "basicPlusChecklist", // Exclude basicPlusChecklist from general handling since we handle it specially
                "secondaryDiagnosis", // Exclude secondaryDiagnosis from general handling since we handle it specially
                "staffTime",
                "staffTimeStart",
            ];
            for (const [field, [oldValue, newValue]] of Object.entries(changes || {})) {
                const nullValues = [null, undefined, "", "None", [], {}];
                // Check if both values are essentially empty/null
                const isOldEmpty = nullValues.includes(oldValue) ||
                    (Array.isArray(oldValue) && oldValue.length === 0) ||
                    (typeof oldValue === "object" && oldValue !== null && Object.keys(oldValue).length === 0);
                const isNewEmpty = nullValues.includes(newValue) ||
                    (Array.isArray(newValue) && newValue.length === 0) ||
                    (typeof newValue === "object" && newValue !== null && Object.keys(newValue).length === 0);
                if (!fieldsToExclude.includes(field) &&
                    oldValue !== newValue &&
                    !(isOldEmpty && isNewEmpty) // Don't show changes when both are empty
                ) {
                    const fieldTitle = field
                        .replace(/([A-Z])/g, " $1") // Add space before capital letters
                        .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
                    const displayOldValue = isOldEmpty ? "Empty" : oldValue ?? "Empty";
                    const displayNewValue = isNewEmpty ? "Empty" : newValue ?? "Empty";
                    details.push(`${fieldTitle}: "${displayOldValue}" -> "${displayNewValue}"`);
                }
            }
            return details;
        };
        // The autocomplete answers absent information in prose rather than leaving a field blank, so
        // "Not applicable" / "Not documented" / "None documented" are answer VALUES, not empty slots
        // (LAM-4620 — most of the noise in the log was these). Treat them as no answer so a question
        // that only ever held a placeholder never produces a log line.
        //
        // Mirrors the vocabulary the backend already uses for the same judgement: _PLACEHOLDER_EXACT /
        // _PLACEHOLDER_MARKERS in logic/ai/policy_review/prior_auth_policy_alignment_flagger.py and
        // _NON_MEANINGFUL in logic/historical_analysis/compare.py. Bare "None" is deliberately absent —
        // for questions like "any known allergies?" it is a real clinical answer.
        const NON_ANSWER_EXACT = new Set(["", "n/a", "na", "unknown", "not applicable", "none documented"]);
        const NON_ANSWER_PREFIXES = ["not documented", "no documentation found"];
        const isNonAnswer = (value) => {
            const normalized = (value || "")
                .trim()
                .toLowerCase()
                .replace(/[.\s]+$/, "");
            if (NON_ANSWER_EXACT.has(normalized))
                return true;
            return NON_ANSWER_PREFIXES.some((prefix) => normalized.startsWith(prefix));
        };
        // Joined answer for a checklist item, or "" when it carries no real answer.
        const meaningfulAnswer = (item) => {
            const answer = item?.options?.map((opt) => opt.label).join(", ") || "";
            return isNonAnswer(answer) ? "" : answer;
        };
        const formatChecklistChanges = (oldChecklist, newChecklist) => {
            const details = [];
            const oldItems = typeof oldChecklist === "string" ? JSON.parse(oldChecklist || "[]") : oldChecklist || [];
            const newItems = typeof newChecklist === "string" ? JSON.parse(newChecklist || "[]") : newChecklist || [];
            // Ensure we have arrays, not null
            const oldItemsArray = Array.isArray(oldItems) ? oldItems : [];
            const newItemsArray = Array.isArray(newItems) ? newItems : [];
            const oldMap = new Map(oldItemsArray.map((item) => [item.label, item]));
            const newMap = new Map(newItemsArray.map((item) => [item.label, item]));
            // Get all unique question labels
            const allQuestions = new Set([...oldMap.keys(), ...newMap.keys()]);
            for (const questionLabel of allQuestions) {
                const oldItem = oldMap.get(questionLabel);
                const newItem = newMap.get(questionLabel);
                const oldAnswers = meaningfulAnswer(oldItem);
                const newAnswers = meaningfulAnswer(newItem);
                if (!oldItem && newItem) {
                    // Question appeared. Only a real answer is worth a line — an unanswered question dropping
                    // in is checklist churn, not an edit (LAM-4620): every save posts the whole checklist, so
                    // conditionally-hidden questions enter and leave on their own.
                    if (newAnswers) {
                        details.push(`${questionLabel}: ${newAnswers}`);
                    }
                }
                else if (oldItem && !newItem) {
                    // Question disappeared — same churn as above, in the other direction. Nobody answered
                    // anything, so there is nothing to report.
                    continue;
                }
                else if (oldAnswers !== newAnswers) {
                    // Question exists in both and the answer really changed. "Empty" matches the wording the
                    // generic field diff already uses (e.g. `Daw: "Empty" -> "No"`) — deliberately NOT
                    // "Not applicable", which on this screen is one of the model's own answers.
                    if (oldAnswers && newAnswers) {
                        details.push(`${questionLabel}: ${oldAnswers} -> ${newAnswers}`);
                    }
                    else if (oldAnswers && !newAnswers) {
                        details.push(`${questionLabel}: ${oldAnswers} -> Empty`);
                    }
                    else {
                        details.push(`${questionLabel}: Empty -> ${newAnswers}`);
                    }
                }
            }
            return details;
        };
        const formatSecondaryDiagnosisChanges = (oldDiagnosis, newDiagnosis) => {
            const details = [];
            const oldItems = typeof oldDiagnosis === "string" ? JSON.parse(oldDiagnosis || "[]") : oldDiagnosis || [];
            const newItems = typeof newDiagnosis === "string" ? JSON.parse(newDiagnosis || "[]") : newDiagnosis || [];
            // Get the maximum length to handle all entries
            const maxLength = Math.max(oldItems.length, newItems.length);
            for (let i = 0; i < maxLength; i++) {
                const oldItem = oldItems[i] || { icd10_code: null, name: null };
                const newItem = newItems[i] || { icd10_code: null, name: null };
                const index = i + 1;
                const oldIcd10 = oldItem.icd10_code || "Empty";
                const newIcd10 = newItem.icd10_code || "Empty";
                const oldName = oldItem.name || "Empty";
                const newName = newItem.name || "Empty";
                // Check if ICD10 code changed
                if (oldIcd10 !== newIcd10) {
                    details.push(`Secondary Diagnosis: (${index}) Icd10 Code "${oldIcd10}" -> "${newIcd10}"`);
                }
                // Check if name changed
                if (oldName !== newName) {
                    details.push(`Secondary Diagnosis: (${index}) Name "${oldName}" -> "${newName}"`);
                }
            }
            return details;
        };
        // Helper function to extract filename from URL (between last slash and ?)
        const extractFilenameFromUrl = (url) => {
            if (!url || typeof url !== "string")
                return null;
            const urlWithoutParams = url.split("?")[0]; // Remove query parameters
            const urlParts = urlWithoutParams.split("/");
            return urlParts[urlParts.length - 1] || null;
        };
        const documentIdentity = (url, fallback) => typeof url === "string" && url ? url.split("?")[0] : fallback;
        /** Multiset diff, so N copies of one name are N events rather than none.
         *
         * A document matched by identity can still have been renamed, and identity deliberately ignores the
         * label, so the rename is reported rather than swallowed. */
        const diffDocumentEntries = (oldEntries, newEntries) => {
            const unmatched = new Map();
            oldEntries.forEach((entry) => {
                const displays = unmatched.get(entry.key) ?? [];
                displays.push(entry.display);
                unmatched.set(entry.key, displays);
            });
            // Settle exact label matches first, so reordering two entries that share an identity but not a
            // label is not mistaken for a pair of renames.
            const unsettled = [];
            newEntries.forEach((entry) => {
                const displays = unmatched.get(entry.key);
                const at = displays ? displays.indexOf(entry.display) : -1;
                if (at >= 0)
                    displays?.splice(at, 1);
                else
                    unsettled.push(entry);
            });
            const added = [];
            const renamed = [];
            unsettled.forEach((entry) => {
                const displays = unmatched.get(entry.key);
                if (displays?.length)
                    renamed.push({ from: displays.shift(), to: entry.display });
                else
                    added.push(entry.display);
            });
            return { added, removed: [...unmatched.values()].flat(), renamed };
        };
        const formatPatientChartChanges = (oldChart, newChart) => {
            const details = [];
            const oldItems = typeof oldChart === "string" ? JSON.parse(oldChart || "[]") : oldChart || [];
            const newItems = typeof newChart === "string" ? JSON.parse(newChart || "[]") : newChart || [];
            // A linkless row is a placeholder awaiting an upload, not a document, so it keys on its label as
            // it always did. Keying it on position instead would turn deleting any earlier document into a
            // spurious remove-plus-add for every placeholder below it.
            // patient_chart is a JSONField, so a label can be any JSON value. Only a non-blank string names a
            // document; anything else falls through to the link rather than rendering as "[object Object]".
            const toEntry = (item) => {
                if (!item)
                    return null;
                const link = item.links?.[0];
                const label = typeof item.label === "string" ? item.label.trim() : "";
                const display = label || extractFilenameFromUrl(link);
                if (!display)
                    return null;
                return { key: documentIdentity(link, `label:${display}`), display };
            };
            const oldEntries = oldItems.map(toEntry).filter(Boolean);
            const newEntries = newItems.map(toEntry).filter(Boolean);
            const { added, removed, renamed } = diffDocumentEntries(oldEntries, newEntries);
            added.forEach((file) => {
                details.push(`Patient Chart: Added file "${file}"`);
            });
            removed.forEach((file) => {
                details.push(`Patient Chart: Removed file "${file}"`);
            });
            renamed.forEach(({ from, to }) => {
                details.push(`Patient Chart: Renamed file "${from}" to "${to}"`);
            });
            return details;
        };
        const formatMedicalNecessityChanges = (oldNecessity, newNecessity) => {
            const details = [];
            const oldUrls = typeof oldNecessity === "string" ? JSON.parse(oldNecessity || "[]") : oldNecessity || [];
            const newUrls = typeof newNecessity === "string" ? JSON.parse(newNecessity || "[]") : newNecessity || [];
            const toEntry = (url) => {
                const display = extractFilenameFromUrl(url);
                if (!display)
                    return null;
                return { key: documentIdentity(url, `name:${display}`), display };
            };
            const oldEntries = oldUrls.map(toEntry).filter(Boolean);
            const newEntries = newUrls.map(toEntry).filter(Boolean);
            const { added, removed, renamed } = diffDocumentEntries(oldEntries, newEntries);
            added.forEach((file) => {
                details.push(`Medical Necessity: Added file "${file}"`);
            });
            removed.forEach((file) => {
                details.push(`Medical Necessity: Removed file "${file}"`);
            });
            renamed.forEach(({ from, to }) => {
                details.push(`Medical Necessity: Renamed file "${from}" to "${to}"`);
            });
            return details;
        };
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "activity-card__header" }, [
                    _createElementVNode("h2", { class: "activity-card__title" }, "Logs")
                ], -1)),
                (__props.withNotes)
                    ? (_openBlock(), _createBlock(UserNote, {
                        key: 0,
                        class: "activity-card__composer",
                        title: "",
                        "order-info-id": __props.orderInfoId,
                        "intake-order-id": __props.intakeOrderId,
                        "intake-document-id": __props.intakeDocumentId,
                        onAddNote: addNote,
                        onMentionsSent: _cache[0] || (_cache[0] = (assigned) => emit('mentions-sent', assigned))
                    }, null, 8, ["order-info-id", "intake-order-id", "intake-document-id"]))
                    : _createCommentVNode("", true),
                (errorMsg.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMsg.value), 1))
                    : _createCommentVNode("", true),
                (showLoader.value)
                    ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 2,
                        type: "list-item-three-line",
                        class: "activity-card__loader"
                    }))
                    : (entries.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_v_icon, {
                                size: "18",
                                class: "mr-2"
                            }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                        _createTextVNode("mdi-history", -1)
                                    ]))]),
                                _: 1
                            }),
                            _cache[9] || (_cache[9] = _createTextVNode(" No logs yet ", -1))
                        ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: entry.id
                                    }, [
                                        ((entry.orderInfo && entry.logEntry?.action === 'update' && orderInfoDetails(entry).length > 0) ||
                                            entry.userNote ||
                                            entry.outgoingFaxTask ||
                                            ((entry.intakeOrder || entry.intakeDocument) &&
                                                (entry.logEntry?.action !== 'update' || intakeStatusDetails(entry).length > 0)) ||
                                            entry.incomingFax)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["activity-entry__icon", `activity-entry__icon--${entryKind(entry)}`])
                                                    }, [
                                                        _createVNode(_component_v_icon, { size: "15" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(entryIcon(entry)), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ], 2),
                                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "activity-entry__line" }, null, -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        _createElementVNode("span", _hoisted_9, _toDisplayString(entry.logEntry?.userFullName || "System"), 1),
                                                        (entry.intakeOrder)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Order " + _toDisplayString(entry.intakeOrder.id), 1))
                                                            : (entry.intakeDocument)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Doc " + _toDisplayString(entry.intakeDocument.documentKey), 1))
                                                                : _createCommentVNode("", true),
                                                        _createElementVNode("span", _hoisted_12, _toDisplayString(entry.date.toLocaleString()), 1)
                                                    ]),
                                                    (entry.userNote)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (noteAttachment(entry) && !noteText(entry))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(showInlineImage(entry) ? "Added an image" : "Uploaded a file"), 1))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createElementVNode("div", _hoisted_14, [
                                                                        _createTextVNode(_toDisplayString(entry.userNote.level === _unref(USER_NOTE_LEVEL).ARCHIVE_REASON ? "Archive reason" : "Added a note") + " ", 1),
                                                                        (entry.userNote.edited)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(edited)"))
                                                                            : _createCommentVNode("", true),
                                                                        (canEditNote(entry) && editingNoteId.value !== entry.userNote.id)
                                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                                key: 1,
                                                                                icon: "mdi-pencil-outline",
                                                                                variant: "text",
                                                                                size: "x-small",
                                                                                class: "activity-entry__edit",
                                                                                "aria-label": "Edit comment",
                                                                                onClick: ($event) => (startNoteEdit(entry))
                                                                            }, null, 8, ["onClick"]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    (editingNoteId.value === entry.userNote.id)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                                            _withDirectives(_createElementVNode("textarea", {
                                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editNoteText).value = $event)),
                                                                                class: "activity-note-edit__input",
                                                                                rows: "3"
                                                                            }, null, 512), [
                                                                                [_vModelText, editNoteText.value]
                                                                            ]),
                                                                            (editNoteError.value)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(editNoteError.value), 1))
                                                                                : _createCommentVNode("", true),
                                                                            _createElementVNode("div", _hoisted_18, [
                                                                                _createVNode(_component_v_btn, {
                                                                                    size: "x-small",
                                                                                    variant: "text",
                                                                                    disabled: savingNoteEdit.value,
                                                                                    onClick: cancelNoteEdit
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                                                            _createTextVNode(" Cancel ", -1)
                                                                                        ]))]),
                                                                                    _: 1
                                                                                }, 8, ["disabled"]),
                                                                                _createVNode(_component_v_btn, {
                                                                                    size: "x-small",
                                                                                    color: "primary",
                                                                                    variant: "flat",
                                                                                    disabled: !editNoteText.value.trim(),
                                                                                    loading: savingNoteEdit.value,
                                                                                    onClick: ($event) => (saveNoteEdit(entry))
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                                            _createTextVNode(" Save ", -1)
                                                                                        ]))]),
                                                                                    _: 1
                                                                                }, 8, ["disabled", "loading", "onClick"])
                                                                            ])
                                                                        ]))
                                                                        : (noteText(entry))
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                                                _createVNode(StatusNoteText, {
                                                                                    text: noteText(entry)
                                                                                }, null, 8, ["text"])
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                ], 64)),
                                                            (showInlineImage(entry))
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 2,
                                                                    type: "button",
                                                                    class: "activity-image-button",
                                                                    "aria-label": "View image full screen",
                                                                    onClick: ($event) => (openImageViewer(entry))
                                                                }, [
                                                                    _createElementVNode("img", {
                                                                        class: "activity-image",
                                                                        src: noteAttachment(entry).fileUrl,
                                                                        alt: "Attached image",
                                                                        loading: "lazy",
                                                                        onError: ($event) => (brokenImageUrls.value.add(noteAttachment(entry).fileUrl))
                                                                    }, null, 40, _hoisted_21)
                                                                ], 8, _hoisted_20))
                                                                : (noteAttachment(entry))
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 3,
                                                                        class: "activity-file-chip",
                                                                        onClick: ($event) => (downloadFiles([noteAttachment(entry).fileUrl]))
                                                                    }, [
                                                                        _createVNode(_component_v_icon, { size: "14" }, {
                                                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                                    _createTextVNode("mdi-paperclip", -1)
                                                                                ]))]),
                                                                            _: 1
                                                                        }),
                                                                        _createElementVNode("span", null, _toDisplayString(noteAttachment(entry).fileName), 1),
                                                                        _createVNode(_component_v_icon, { size: "13" }, {
                                                                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                                    _createTextVNode("mdi-download", -1)
                                                                                ]))]),
                                                                            _: 1
                                                                        })
                                                                    ], 8, _hoisted_22))
                                                                    : _createCommentVNode("", true),
                                                            (canAcknowledge(entry))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: _normalizeClass(["activity-ack__chip", { 'activity-ack__chip--active': hasAcked(entry) }]),
                                                                        "aria-label": hasAcked(entry) ? 'Remove acknowledgement' : 'Acknowledge',
                                                                        disabled: ackPending.value.has(entry.userNote.id),
                                                                        onClick: ($event) => (toggleAcknowledge(entry))
                                                                    }, [
                                                                        _createVNode(_component_v_icon, { size: "14" }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(hasAcked(entry) ? "mdi-thumb-up" : "mdi-thumb-up-outline"), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1024),
                                                                        (ackCount(entry))
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(ackCount(entry)), 1))
                                                                            : _createCommentVNode("", true)
                                                                    ], 10, _hoisted_24),
                                                                    (ackNames(entry))
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(ackNames(entry)), 1))
                                                                        : _createCommentVNode("", true),
                                                                    (ackErrors.value.has(entry.userNote.id))
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Failed to update — please try again. "))
                                                                        : _createCommentVNode("", true)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : (entry.outgoingFaxTask)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createElementVNode("div", _hoisted_28, " Sent " + _toDisplayString(entry.outgoingFaxTask.description || "a fax") + " to " + _toDisplayString(_unref(formatContactNumber)(entry.outgoingFaxTask.toFaxNumber)), 1),
                                                                _createElementVNode("div", _hoisted_29, " From " + _toDisplayString(_unref(formatContactNumber)(entry.outgoingFaxTask.fromFaxNumber)) + " — status " + _toDisplayString(entry.outgoingFaxTask.status?.toLowerCase()) + " at " + _toDisplayString(entry.outgoingFaxTask.statusModifiedOn?.toLocaleString()), 1),
                                                                (entry.outgoingFaxTask.fileLinks)
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 0,
                                                                        class: "activity-file-chip",
                                                                        onClick: ($event) => (downloadFiles(entry.outgoingFaxTask.fileLinks))
                                                                    }, [
                                                                        _createVNode(_component_v_icon, { size: "14" }, {
                                                                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                                    _createTextVNode("mdi-download", -1)
                                                                                ]))]),
                                                                            _: 1
                                                                        }),
                                                                        _createElementVNode("span", null, " Download fax (" + _toDisplayString(entry.outgoingFaxTask.fileLinks.length) + " " + _toDisplayString(_unref(pluralize)(entry.outgoingFaxTask.fileLinks.length, "file", "files")) + ") ", 1)
                                                                    ], 8, _hoisted_30))
                                                                    : _createCommentVNode("", true)
                                                            ], 64))
                                                            : (entry.intakeOrder && entry.logEntry?.action === 'update')
                                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(intakeStatusDetails(entry), (detail) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: detail,
                                                                        class: "activity-entry__action"
                                                                    }, _toDisplayString(detail), 1));
                                                                }), 128))
                                                                : (entry.intakeOrder && entry.logEntry?.action === 'create')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Created the order"))
                                                                    : (entry.intakeDocument && entry.logEntry?.action === 'update')
                                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(intakeStatusDetails(entry), (detail) => {
                                                                            return (_openBlock(), _createElementBlock("div", {
                                                                                key: detail,
                                                                                class: "activity-entry__action"
                                                                            }, _toDisplayString(detail), 1));
                                                                        }), 128))
                                                                        : (entry.intakeDocument && entry.logEntry?.action === 'create')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Created the document"))
                                                                            : (entry.incomingFax)
                                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                                                    _createElementVNode("div", _hoisted_33, " Received a fax from " + _toDisplayString(_unref(formatContactNumber)(entry.incomingFax.fromFaxNumber)), 1),
                                                                                    (entry.incomingFax.fileLinks)
                                                                                        ? (_openBlock(), _createElementBlock("button", {
                                                                                            key: 0,
                                                                                            class: "activity-file-chip",
                                                                                            onClick: ($event) => (downloadFiles(entry.incomingFax.fileLinks))
                                                                                        }, [
                                                                                            _createVNode(_component_v_icon, { size: "14" }, {
                                                                                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                                                        _createTextVNode("mdi-download", -1)
                                                                                                    ]))]),
                                                                                                _: 1
                                                                                            }),
                                                                                            _createElementVNode("span", null, " Download fax (" + _toDisplayString(entry.incomingFax.fileLinks.length) + " " + _toDisplayString(_unref(pluralize)(entry.incomingFax.fileLinks.length, "file", "files")) + ") ", 1)
                                                                                        ], 8, _hoisted_34))
                                                                                        : _createCommentVNode("", true)
                                                                                ], 64))
                                                                                : (entry.orderInfo && isTagOnlyChange(entry))
                                                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(tagChangeDetails(entry), (detail) => {
                                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                                            key: detail,
                                                                                            class: "activity-entry__action"
                                                                                        }, _toDisplayString(detail), 1));
                                                                                    }), 128))
                                                                                    : (entry.orderInfo && entry.logEntry?.action === 'update' && orderInfoDetails(entry).length > 0)
                                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                                                                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "activity-entry__action" }, "Updated submission", -1)),
                                                                                            _createElementVNode("div", _hoisted_35, [
                                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderInfoDetails(entry), (detail, detailIndex) => {
                                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                                        key: `${detail}-${detailIndex}`,
                                                                                                        class: "activity-entry__detail"
                                                                                                    }, _toDisplayString(detail), 1));
                                                                                                }), 128))
                                                                                            ])
                                                                                        ], 64))
                                                                                        : (entry.orderInfo && entry.logEntry?.action === 'create')
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Created the submission"))
                                                                                            : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 128))
                            ]),
                            (hasPrevious.value || hasNext.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createVNode(_component_v_btn, {
                                        icon: "mdi-chevron-left",
                                        variant: "text",
                                        size: "small",
                                        density: "comfortable",
                                        disabled: !hasPrevious.value,
                                        "aria-label": "Previous logs",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (fetchPage(false)))
                                    }, null, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                        icon: "mdi-chevron-right",
                                        variant: "text",
                                        size: "small",
                                        density: "comfortable",
                                        disabled: !hasNext.value,
                                        "aria-label": "Next logs",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (fetchPage(true)))
                                    }, null, 8, ["disabled"])
                                ]))
                                : _createCommentVNode("", true)
                        ], 64)),
                _createVNode(_component_v_dialog, {
                    modelValue: imageViewerOpen.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((imageViewerOpen).value = $event)),
                    fullscreen: "",
                    transition: "fade-transition"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(imageViewerName.value), 1),
                                _createVNode(_component_v_btn, {
                                    icon: "mdi-download",
                                    variant: "text",
                                    size: "small",
                                    density: "comfortable",
                                    "aria-label": "Download image",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (downloadFiles([imageViewerUrl.value])))
                                }),
                                _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    variant: "text",
                                    size: "small",
                                    density: "comfortable",
                                    "aria-label": "Close image viewer",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (imageViewerOpen.value = false))
                                })
                            ]),
                            _createElementVNode("div", {
                                class: "image-viewer__body",
                                onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (imageViewerOpen.value = false), ["self"]))
                            }, [
                                _createElementVNode("img", {
                                    class: "image-viewer__img",
                                    src: imageViewerUrl.value,
                                    alt: imageViewerName.value,
                                    onError: onViewerImageError
                                }, null, 40, _hoisted_41)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
